import { clsx } from 'clsx'
import { useLocation } from 'react-router'

import { useFvNavigate } from '@fv/client-components'
import type { PropsWithClassName, SelectFieldOption } from '@fv/client-types'
import type { AuditSortType } from '@fv/models'

import { SelectField } from '@/components/inputs/SelectField'

type Props = PropsWithClassName<{
  includeAccepted?: boolean
  value: AuditSortType
}>

export const AuditSortSelect = ({
  value,
  className,
  includeAccepted,
}: Props) => {
  const { pathname, search } = useLocation()
  const navigate = useFvNavigate()

  const options: SelectFieldOption<AuditSortType>[] = [
    {
      text: 'Pickup date',
      value: 'pickupDate',
    },
    ...(includeAccepted
      ? [
          {
            text: 'Accepted date',
            value: 'acceptedDate' as const,
          },
        ]
      : []),
  ]

  const handleSelect = (val: AuditSortType) => {
    if (val === value) return

    const params = new URLSearchParams(search)
    params.set('sortBy', val)
    navigate(`${pathname}?${params.toString()}`)
  }

  return (
    <SelectField
      aria-label="Sort audits by"
      className={clsx('w-full ml-1', className)}
      options={options}
      name="sortBy"
      value={value}
      onChange={e => handleSelect(e.target.value as AuditSortType)}
    />
  )
}
